module.exports = __webpack_public_path__ + "static/img/jiang.86e18bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/jiang.jpg
// module id = QgxH
// module chunks = 4